export const ERROR_DEFAULT = 'There was an error with your request'
export const ERROR_422 = 'There are errors with your form'
